// TSPL model settings; hardware validation is still required on each printer.
export function isY428Printer(name: string): boolean {
  return /^Y428BT(?:$|[-_\s])/i.test(name.trim());
}

export function tsplProfile(name: string, dpi = 203) {
  const y428 = isY428Printer(name);
  return {
    dpi: y428 ? 300 : (dpi === 300 ? 300 : 203),
    bitmapMode: y428 ? 1 as const : 0 as const,
    legacyMargins: !y428,
  };
}
